import axios from 'axios';
import Cookies from "js-cookie";
import md5 from "md5";
import Debug from 'debug';

/* eslint-disable no-unused-expressions */

const getUserQueryObject = async () => {
	try {
		Debug(`cig:info:sage:function:buildCigObjectsUrl`)(`getUserQueryObject start`);

		// Object to be returned
		const queryObject = {};

		// Get Current User Details
		const response = await axios.get(`/wp-ajax?action=cig_get_current_user`);

		// If there is a user logged in currently (is this ever not true?)
		if (response.data.isUserLoggedIn) {
			queryObject.personid = response.data.personId || '';

			// No user currently logged in
		} else {
			// Check cookies for pid
			const cookiedPid = Cookies.get('pid');

			// If pid found in cookies
			if (cookiedPid !== undefined) {
				queryObject.personid = cookiedPid;
			}
		}

		// Send secret to My Account if we have a personId regardless of login status
		if (queryObject.personid) {
			queryObject.secret = md5(`${queryObject.personid}cigkey`);
		}

		return queryObject;

	} catch (err) {
		Debug(`cig:error:sage:function:buildCigObjectsUrl`)(`getUserQueryObject Error: %s %o`, err.message, err);
		throw new Error(err);
	}
};

/**
 * Use Environment variables to build a url for CigObjects
 *
 * @param {string} controller The name of the CIG Objects controller
 * @param {string} action The name of the method to execute on the controller, this may include a .json extension
 *
 * @return {string} CIG Objects URL with query string
 */
const buildCigObjectsUrl = async (controller, action) => {
	try {
		Debug(`cig:info:sage:function:buildCigObjectsUrl`)(`buildCigObjectsUrl start`);

		// Get object with personid and secret
		const userQueryObject = await getUserQueryObject();

		// Get CIG Objects URL
		const response = await axios.get(`/wp-ajax?action=cig_get_cig_objects_url`);

		// Create URL object
		const cigObjectsUrl = new URL(`${response.data.url}${controller}/${action}`);

		// Add Query String to URL
		for (const [key, value] of Object.entries(userQueryObject)) {
			cigObjectsUrl.searchParams.append(key, value);
		}

		// Get the current URL query string params
		const currUrlParams = new URL(window.location.href).searchParams;

		// Add the current URL query string params to the Objects URL
		for (const [key, value] of currUrlParams.entries()) {
			cigObjectsUrl.searchParams.append(key, value);
		}

		// Return the url with query string
		return cigObjectsUrl.href;
	} catch (err) {
		Debug(`cig:error:sage:function:buildCigObjectsUrl`)(`buildCigObjectsUrl Error: %s %o`, err.message, err);
		throw new Error(err);
	}
};

export default buildCigObjectsUrl;
